'use strict';

var _Aligner = require('./Aligner');

var _BlotFormatter = require('../../BlotFormatter');

var _BlotFormatter2 = _interopRequireDefault(_BlotFormatter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }